export const binanceAccountCategory = 'binance'

export const networkEvmChainIds: Record<string, number | undefined> = {
  ARBITRUM: 42161,
  AVAXC: 43114,
  BASE: 8453,
  BERA: 80094,
  BSC: 56,
  ETH: 1,
  FTM: 250,
  GLMR: 1284,
  MANTA: 169,
  MATIC: 137,
  METIS: 1088,
  MOVR: 1285,
  OPBNB: 204,
  OPTIMISM: 10,
  RON: 2020,
  SCROLL: 534352,
  SONIC: 146,
  ZKSYNCERA: 324,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  ASTR: 2006,
  DOT: 0,
  STATEMINT: 1000,
}

export const solanaNetwork = 'SOL'
